// Resolves issues with grammarly extension breaking quill: https://github.com/quilljs/quill/issues/574

import Inline from 'quill/blots/inline';

class GrammarlyInline extends Inline {}
GrammarlyInline.tagName = 'G';
GrammarlyInline.blotName = 'grammarly-inline';
GrammarlyInline.className = 'gr_';

export default GrammarlyInline;


//////////////////
// WEBPACK FOOTER
// ./config/grammarly.js
// module id = null
// module chunks = 